import styled from "@emotion/styled";
import { LdInputMessage } from "@liquid/react";

const StyledErrorInputMessage = styled(LdInputMessage)<{ visible: boolean }>`
  // Works as placeholder for ErrorMessage
  display: flex;
  align-items: center;
  visibility: ${(props) => (props.visible ? "visible" : "hidden")};
  min-height: 22px;

  &::part(icon) {
    margin-top: 0;
    transform: none;
  }
`;

export { StyledErrorInputMessage };
